export enum PopupAction {
    Open = 'open',
    ManualClose = 'manualClose',
    CloseByNavigation = 'closeByNavigation',
    CloseByMybets = 'CloseByMybets',
    CloseByNextPopup = 'CloseByNextPopup',
    CloseByPan = 'CloseByPan',
    SilentClose = 'SilentClose',
}

export interface PopupClosingResult {
    closeAction: PopupAction;
}

export enum CloseButtonType {
    Icon = 'Icon',
    Button = 'Button',
}

export interface GestureOptions {
    enabled?: boolean;
    headerSelector?: string;
    scrollTargetQuerySelector?: string;
    restorePreviousUrl?: boolean;
}
